module.exports = __webpack_public_path__ + "img/title.c7747171.png";